const authentication = require('../../../react-azure-adb2c2').default;







export const list = (values: any) => {
  //   if(values.date1){
  //   const date1 = new Date(values.date1);
  //   const year = date1.getFullYear();
  //   const month = date1.getMonth() + 1;
  //   const day = date1.getDate();
  //   values.date1 = year + '/' + month + '/' + day
  //   }
  //   if(values.date2){

  //   const date2 = new Date(values.date2);
  //   const year2 = date2.getFullYear();
  //   const month2 = date2.getMonth() + 1;
  //   const day2 = date2.getDate();

  //   values.date2 = year2 + '/' + month2 + '/' + day2
  // }
  // values.output =values.output===true?1:0

  // let url = `https://homestationapi.azurewebsites.net/api/kyousai?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;
  // let url = `https://localhost:44341/api/Kyousai`;
  // let url = `https://moniesapi.azurewebsites.net/api/v1/kyousais`;
  // let url = `https://localhost:44341/api/banks?output=`+values.output+'&name='+values.name+'&date1='+values.date1+'&date2='+values.date2;

  // alert(url)
  const url = process.env.REACT_APP_API_BASE_URL + `/v1/rent/transfer/accounts`;
  // let url = `http://localhost:5000/v1/rent/transfer/accounts`;
  const token = authentication.getAccessToken();
  // console.log(JSON.stringify(values))
  // alert(JSON.stringify(values))
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



  //  return  fetch(url, {
  //             method: 'get',
  //             // body: JSON.stringify(search),

  //             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //         }).then(res => res.json())
  //         .then(payload => ({ payload }))
  //             .catch(error => ({ error }));
  //       return  fetch(url, {
  //       method: 'get',
  //       // body: JSON.stringify(accountinglistset),

  //       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //   })
  //   .then(res => res.json())
  //   .then(payload => ({ payload }))
  //       .catch(error => ({ error }));






};


export const insert = (values: any) => {
    // const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/getTransferList`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/getTransferList`;
    // alert(url)
  
  
    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
      method: 'post',
      body: JSON.stringify(values),
      headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
    }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));
  
  
  
  
  };
  




export const update = (values: any) => {
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/update`;
  // let url = `http://localhost:5000/api/v1/kyousais/update`;
  // alert(url)


  const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



  //  return  fetch(url, {
  //             method: 'get',
  //             // body: JSON.stringify(search),

  //             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //         }).then(res => res.json())
  //         .then(payload => ({ payload }))
  //             .catch(error => ({ error }));
  //       return  fetch(url, {
  //       method: 'get',
  //       // body: JSON.stringify(accountinglistset),

  //       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //   })
  //   .then(res => res.json())
  //   .then(payload => ({ payload }))
  //       .catch(error => ({ error }));






};



export const deletetransfer = (values: any) => {
  // const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/delete`;
  // let url = `http://localhost:5000/api/v1/kyousais/deletekyousais`;
  // let url = `http://localhost:5000/v1/rent/transfer/accounts/delete`;

  const url = process.env.REACT_APP_API_BASE_URL + `/v1/rent/transfer/accounts/delete`;

  const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));





};




export const updatekakumei = (values: any) => {
  // const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/delete`;
  // let url = `http://localhost:5000/v1/kakumei/kys/mst/hikikozareact`;
  // let url = `https://192.168.0.207/fuelphp-1.8/public/contraction/rest/list/hikikozareact.json`
  const url = process.env.REACT_APP_API_BASE_URL + `/v1/kakumei/kys/mst/hikikozareact`;


  const token = authentication.getAccessToken();
  // alert(JSON.stringify(values))
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));





};



export const upload_csv = (payload: any) => {

  var formData = new FormData();
  formData.append(payload.id, payload.file[0]);



  console.log(payload.file)
  console.log(formData.getAll(payload.id))
  // alert(payload.id)
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/uploadcsv`;
  // let url = `http://localhost:5000/api/v1/kyousais/uploadcsv`;
  // alert(url)

  const token = authentication.getAccessToken();
  // alert(JSON.stringify(formData))
  return fetch(url, {
    method: 'post',
    body: formData,

    headers: { 'Authorization': 'Bearer ' + token },

  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
}


// export const detail = (Id: number) => {

//             const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + Id;

//             const token = authentication.getAccessToken();

//             return fetch(url, {
//                 headers: { 'Authorization': 'Bearer ' + token }
//             }).then(res => res.json())
//                 .then(payload => ({ payload }))
//                 .catch(error => ({ error }));


//     }




export const matching = (values: any) => {
  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/matching`;
  // let url = `http://localhost:5000/api/v1/kyousais/matching`;


  // alert(url)

  const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
    method: 'get',
    // body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));

};



export const downloadcsv = (values: any) => {


  const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais`;
  // const url = `http://localhost:5000/api/v1/kyousais`;

  // let url = `https://localhost:44341/api/RentContractAccounting`;

  const token = authentication.getAccessToken();
  values.csv = 1

  // alert(JSON.stringify(accountinglistset))
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),

    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  }).then(response => response.blob())
    .then(payload => ({ payload }))
    // .then(res => res.json())
    // .then(payload => ({ payload }))
    .catch(error => ({ error }));






};




export const gettransferlist = (values: any) => {
    // const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/delete`;
    // let url = `http://localhost:5000/api/v1/kyousais/deletekyousais`;
    // let url = `http://localhost:5000/v1/rent/transfer/accounts/delete`;
    var startdate = String(values.StartDate).replace(/\//g, "");
    var enddate = String(values.EndDate).replace(/\//g, "");
    // const url = process.env.REACT_APP_API_BASE_URL + `/v1/rent/transfer/accounts/delete`;
    let url = process.env.REACT_APP_API_BASE_URL + '/v1/rent/transfer/accounts/getTransferList/' + startdate + '/' + enddate;
  
    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
      method: 'get',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
    }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));
  };

  
export const applicationregistration = (values: any) => {
    // const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/delete`;
    // let url = `http://localhost:5000/api/v1/kyousais/deletekyousais`;
    // let url = `http://localhost:5000/v1/rent/transfer/accounts/delete`;
    // const url = process.env.REACT_APP_API_BASE_URL + `/v1/rent/transfer/accounts/delete`;
    console.log(values)
    let url = process.env.REACT_APP_API_BASE_URL + '/v1/rent/transfer/accounts/ApplicationRegistration';
  
    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
      method: 'post',
      body: JSON.stringify(values),
      headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
    }).then(res => res.json())
      .then(payload => ({ payload }))
      .catch(error => ({ error }));
  };